import * as yup from 'yup';
import { LANGUAGE_CODE_TO_TITLE } from '@src/constants/Language';

const generalSettingsSchema = yup.object().shape({
  businessName: yup.string().required(),
  businessViaName: yup
    .string()
    .test(
      'test-businessViaName',
      'error message',
      function businessViaNameValidator(value) {
        const { path, createError } = this;
        if (!value) {
          return createError({
            path,
            message: 'Business ViaName is compulsory.',
          });
        }

        if (value.match(/ /g)) {
          return createError({
            path,
            message: 'Business ViaName cannot have spaces.',
          });
        }

        const underscoreCount = (value.match(/_/g) || []).length;
        if (underscoreCount > 1) {
          // business vianame should never have more than 1 underscore
          return createError({
            path,
            message: 'Business ViaName cannot have more than 1 underscore.',
          });
        }
        if (underscoreCount === 1) {
          // The business via_name should be of the format <vianame-prefix>_<language_code>
          const splitList = value.split('_');
          const prefix = splitList[0];
          const languageCode = splitList[1];

          // via name prefix validations. Via name should have only lower case letters and end with "channel"
          if (!prefix.match(/^[a-z0-9]+channel$/)) {
            return createError({
              path,
              message:
                'Business Vianame prefix (i.e. before underscore) should be Lower case letters/Numbers only and end with "channel"',
            });
          }
          // Language code from the via name should be one of the Haptik supported language codes
          if (LANGUAGE_CODE_TO_TITLE[languageCode] === undefined) {
            return createError({
              path,
              message:
                'Please enter a valid language code at the end of the Business Vianame',
            });
          }
        } else if (!value.match(/^[a-z0-9]+channel$/)) {
          // via name prefix validations for business via_name in which language code has not been specified
          return createError({
            path,
            message:
              'Business ViaName should be Lower case letters/Numbers only and end with "channel"',
          });
        }
        return true;
      }
    ),
  activePartners: yup
    .array()
    .max(1)
    .of(yup.string())
    .required(), // cannot be empty
  activeBots: yup.array().of(yup.string()), // can be empty
  defaultBot: yup.mixed(), // optional, if present should be a part of active bots, make the dropdown populate from active bots
  fallbackBot: yup.string().when('activeBots', {
    is: val => val.length,
    then: fieldSchema => fieldSchema.required(),
  }), // compulsory, if present should be a part of active bots, make the dropdown populate from active bots
  collectFeedback: yup.bool().required(), // default: false
  collectFeedbackDelay: yup.number().required(), // 35
  collectFeedbackMultiple: yup.bool().required(), // single multiple
  defaultTeam: yup.string().notRequired(), // optional but non clearable
  enableHumanAssistance: yup.bool(), // defaults
  liveAgentChatTool: yup.string(), // depends on enableHumanAssistant, empty when enableHumanAssistant is false
  enableSmallTalk: yup.bool(), // defaults
  requestsPii: yup.bool(), // if enabled, user files will get deleted after 72 hours
  order: yup
    .number()
    .min(1)
    .max(999)
    .required(), // 0 - 999
  previewText: yup.string(), // optional
  languageCode: yup.string(),
});

export default generalSettingsSchema;
